"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isDefined = void 0;
const isDefined = (value)=>value != null;
exports.isDefined = isDefined;
